import CRUD from '../base/crud'

class ProfileCRUD extends CRUD {
  getProfile() {
    return this.request({
      url: this.url,
    })
  }
  editProfile(id, data) {
    return this.request({
      url: `${this.url}/${id}`,
      method: 'PATCH',
      data,
    })
  }
  sendProfileAvatar(data, params) {
    return this.request({
      url: '/upload',
      method: 'POST',
      data,
      params,
      headers: {
        'Content-Type': 'application/pdf',
      },
    })
  }
}

export default function profileCRUD(request) {
  return new ProfileCRUD({
    url: '/profile',
    request,
  })
}
